import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import {
    trigger,
    state,
    style,
    animate,
    transition,
    AnimationEvent,

} from '@angular/animations';

@Component({
    selector: 'app-custom-modal-reset',
    templateUrl: './custom-modal-reset.component.html',
    styleUrls: ['./custom-modal-reset.component.scss'],
    animations: [
        trigger('openClose', [
            state('open', style({
                opacity: 1,
                transform: 'scale(1)'
            })),
            state('closed', style({
                opacity: 0,
                transform: 'scale(1.3)',
            })),
            transition('open => closed', [
                animate('0.1s')
            ]),
            transition('closed => open', [
                animate('0.2s')
            ]),
        ])
    ]
})
export class CustomModalResetComponent implements OnInit {

    @Input() uuid: string;
    @Input() width: string;
    @Input() height: string;
    @Input() visar: boolean = false;
    @Input() firmar: boolean = false;
    @Input() visarMovil: boolean = false;
    @Input() firmarMovil: boolean = false;
    @Input() cerrar: boolean = true;
    @Input() cerrarMovil: boolean = false;
    @Input() detalle: boolean = true;
    @Output() closeModal = new EventEmitter();
    @Output() onFirmarDocument = new EventEmitter();
    @Output() onVisarDocument = new EventEmitter();
    @Output() onFirmarMovilDocument = new EventEmitter();
    @Output() onVisarMovilDocument = new EventEmitter();

    private $onClose = new Subject<any>()

    isOpen = false;
    showModal = false;
    private isOpen$ = new BehaviorSubject(false);

    constructor(
        @Inject(DOCUMENT) private document: Document
    ) { }

    ngOnInit(): void {
        this.watchState.subscribe(res => {
            this.isOpen = res

            this.isOpen
                ? this.document.body.style.overflowY = 'hidden'
                : this.document.body.style.overflowY = 'auto'
        })
    }

    get watchState(): Observable<boolean> {
        return this.isOpen$.asObservable()
    }

    open() {
        this.isOpen$.next(true);
    }

    close() {
        this.closeModal.emit(true);
        this.isOpen$.next(false);
    }

    toggle() {
        this.isOpen$.next(!this.isOpen);
    }

    onClose(): Observable<null> {
        return this.$onClose.asObservable()
    }

    onClickFirmar() {
        this.onFirmarDocument.emit(true);
    }

    onClickVisar() {
        this.onVisarDocument.emit(true);
    }

    onClickFirmarMovil() {
        this.onFirmarMovilDocument.emit(true);
    }

    onClickVisarMovil() {
        this.onVisarMovilDocument.emit(true);
    }

    onAnimationEvent(e: AnimationEvent) {
        if (e.toState === 'closed' && e.phaseName === 'done') {
            this.showModal = false;
            this.$onClose.next(null)
        } else if (e.toState === 'open' && e.phaseName === 'start') {
            this.showModal = true;
        }

    }

}
